var _mask, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_11_686",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.57143C2 5.0467 4.0467 3 6.57143 3H24.4286C26.9533 3 29 5.0467 29 7.57143V12.1776C27.0918 12.4152 25.625 13.8442 25.625 15.5714C25.625 17.2987 27.0918 18.7276 29 18.9653V22.4286C29 24.9533 26.9533 27 24.4286 27H6.57143C4.0467 27 2 24.9533 2 22.4286V18.9653C2.18367 18.9882 2.37143 19 2.56236 19C4.73698 19 6.49986 17.465 6.49986 15.5714C6.49986 13.6779 4.73698 12.1429 2.56236 12.1429C2.37143 12.1429 2.18367 12.1547 2 12.1776V7.57143Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 12.1776L29.2472 14.1622L31 13.9439V12.1776H29ZM29 18.9653H31V17.1989L29.2472 16.9806L29 18.9653ZM2 18.9653L2.24713 16.9806L0 16.7008V18.9653H2ZM2 12.1776H0V14.442L2.24713 14.1622L2 12.1776ZM6.57143 1C2.94213 1 0 3.94213 0 7.57143H4C4 6.15127 5.15127 5 6.57143 5V1ZM24.4286 1H6.57143V5H24.4286V1ZM31 7.57143C31 3.94213 28.0579 1 24.4286 1V5C25.8487 5 27 6.15127 27 7.57143H31ZM31 12.1776V7.57143H27V12.1776H31ZM27.625 15.5714C27.625 15.0722 28.1066 14.3043 29.2472 14.1622L28.7528 10.1929C26.0771 10.5262 23.625 12.6161 23.625 15.5714H27.625ZM29.2472 16.9806C28.1066 16.8385 27.625 16.0706 27.625 15.5714H23.625C23.625 18.5267 26.0771 20.6167 28.7528 20.9499L29.2472 16.9806ZM31 22.4286V18.9653H27V22.4286H31ZM24.4286 29C28.0579 29 31 26.0579 31 22.4286H27C27 23.8487 25.8487 25 24.4286 25V29ZM6.57143 29H24.4286V25H6.57143V29ZM0 22.4286C0 26.0579 2.94213 29 6.57143 29V25C5.15127 25 4 23.8487 4 22.4286H0ZM0 18.9653V22.4286H4V18.9653H0ZM2.56236 17C2.4541 17 2.34887 16.9933 2.24713 16.9806L1.75287 20.95C2.01847 20.983 2.28876 21 2.56236 21V17ZM4.49986 15.5714C4.49986 16.1094 3.90132 17 2.56236 17V21C5.57265 21 8.49986 18.8205 8.49986 15.5714H4.49986ZM2.56236 14.1429C3.90132 14.1429 4.49986 15.0334 4.49986 15.5714H8.49986C8.49986 12.3223 5.57265 10.1429 2.56236 10.1429V14.1429ZM2.24713 14.1622C2.34887 14.1496 2.4541 14.1429 2.56236 14.1429V10.1429C2.28876 10.1429 2.01847 10.1598 1.75287 10.1929L2.24713 14.1622ZM0 7.57143V12.1776H4V7.57143H0Z",
    fill: "#86868D",
    mask: "url(#path-1-inside-1_11_686)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.7344,
    y1: 3,
    x2: 19.7344,
    y2: 27,
    stroke: "#86868D",
    strokeWidth: 2,
    strokeDasharray: "6.4 6.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.b8c274e41c7d1182ad1009c19edfad8f.svg";
export { ForwardRef as ReactComponent };